import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import useTutorialCache from "@hooks/useTutorialCache";
import { isWeb } from "@memorang/helpers/src/common";
import { Portal } from "react-native-paper";
import { ConfirmDialog } from "./ConfirmDialog";
import DateTimePicker from "./DateTimePicker";

const cta = "Got it";
type Props = {
	showDatePicker: boolean;
	toggleShowDatePicker: () => void;
	handleDateChange?: (date: Date) => void;
};
const SetExamDateContainer = ({
	showDatePicker,
	toggleShowDatePicker,
	handleDateChange,
}: Props) => {
	const { tutorialData, setTutorialData } = useTutorialCache();

	const examDateDisclaimer = useAppStore(
		(state) => state.exam.examDateDisclaimer,
	);

	const {
		currentExamContext: { examDate },
		updateExamDate,
	} = useExamContext();

	const hasSeenTutorial = tutorialData?.hasSeenExamDateTutorial;

	const handleCloseTutorial = () => {
		setTutorialData({ hasSeenExamDateTutorial: true });
		toggleShowDatePicker();
	};

	if (!showDatePicker) {
		return null;
	}
	if (!hasSeenTutorial) {
		return (
			<ConfirmDialog
				visible={true}
				showCloseButton={false}
				title="Disclaimer"
				icon="information-outline"
				body={examDateDisclaimer}
				confirmCallback={handleCloseTutorial}
				confirmCta={cta}
			/>
		);
	}

	return showDatePicker ? (
		<Portal>
			<DateTimePicker
				isVisible
				onCancel={toggleShowDatePicker}
				initialDate={examDate}
				onConfirm={(date) => {
					if (!isWeb) {
						toggleShowDatePicker();
					}
					updateExamDate(date);
					handleDateChange?.(date);
				}}
			/>
		</Portal>
	) : null;
};

export default SetExamDateContainer;
